<template>
  <div>
    <template v-if="mode === 'fields'">
      <!-- 手動入力フィールド（AI自動入力でないテンプレート用） -->
      <div class="edit-form-item" v-if="!showAiCard">
        <div class="item-name">役職・部署名</div>
        <div class="item-body">
          <el-input
            class="input-md"
            placeholder=""
            title="役職・部署名"
            v-model="yakushokuBusho"
          ></el-input>
        </div>
        <div class="item-name">業種</div>
        <div class="item-body">
          <el-select
            v-model="gyoushuCd"
            placeholder="選択してください"
            style="left: 0; max-width: 100%"
          >
            <el-option-group
              v-for="group in industryData"
              :key="group.igCd"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">職種</div>
        <div class="item-body">
          <el-select
            v-model="shokushuCd"
            placeholder="選択してください"
            style="left: 0; max-width: 100%"
          >
            <el-option-group
              v-for="group in jobTypeData"
              :key="group.jgCd"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">希望業種</div>
        <div class="item-body">
          <el-select
            v-model="kibouGyoushuCd"
            placeholder="選択してください"
            style="left: 0; max-width: 100%"
          >
            <el-option-group
              v-for="group in industryData"
              :key="group.igCd"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">希望職種</div>
        <div class="item-body">
          <el-select
            v-model="kibouShokushuCd"
            placeholder="選択してください"
            style="left: 0; max-width: 100%"
          >
            <el-option-group
              v-for="group in jobTypeData"
              :key="group.jgCd"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>

      <!-- 現在の業界・職種: v-model を gyoushuCd/shokushuCd に直接バインド (下のAIカード編集モーダルと同じ実体)。AI推定で basicData がセットされれば自動反映 -->
      <div class="edit-form-item" v-if="formatId === 'rirekisho_job_change'">
        <div class="item-name">現在のあなたのいる業界</div>
        <div class="item-body">
          <el-select
            v-model="gyoushuCd"
            filterable
            placeholder="選択してください"
            style="left: 0; max-width: 100%"
          >
            <el-option-group
              v-for="group in industryData"
              :key="group.igCd"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
        <div class="item-name">現在のあなたのいる職種</div>
        <div class="item-body">
          <el-select
            v-model="shokushuCd"
            filterable
            placeholder="選択してください"
            style="left: 0; max-width: 100%"
          >
            <el-option-group
              v-for="group in jobTypeData"
              :key="group.jgCd"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </div>
      </div>

      <!-- 年収フィールド -->
      <div class="edit-form-item">
        <div class="item-name">現在の年収</div>
        <div class="item-body">
          <el-select
            v-model="nowNensyu"
            placeholder="選択してください"
            style="left: 0; max-width: 100%"
          >
            <el-option label="399万円以下" value="399万円以下"></el-option>
            <el-option label="400万円以上" value="400万円以上"></el-option>
            <el-option label="700万円以上" value="700万円以上"></el-option>
          </el-select>
        </div>
        <div class="item-name">希望年収</div>
        <div class="item-body">
          <el-input
            class="input-xs"
            placeholder=""
            title="希望年収"
            type="number"
            v-model="kibouNensyu"
          ></el-input>
          万円
        </div>
      </div>
      <div class="item-name" style="font-size: 0.8rem">
        ※上記項目を入力した後、例文から追加ボタンをクリックして例文を選択すると自動的に反映されます。
      </div>
    </template>

    <template v-if="mode === 'ai-card'">
      <PersonalRequestEditDialog
        v-if="showAiCard"
        :visible="requestEditDialogVisible"
        @update:visible="requestEditDialogVisible = $event"
      >
        <div class="edit-form-item">
          <div class="item-name">役職・部署名</div>
          <div class="item-body">
            <el-input
              class="input-md"
              placeholder="役職・部署名"
              v-model="yakushokuBusho"
            ></el-input>
          </div>
          <div class="item-name">希望業種</div>
          <div class="item-body">
            <el-select
              v-model="kibouGyoushuCd"
              filterable
              placeholder="選択してください"
              style="left: 0; max-width: 100%"
            >
              <el-option-group
                v-for="group in bizreachIndustryGroups"
                :key="group.igCd"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-option-group>
            </el-select>
          </div>
          <div class="item-name">希望職種</div>
          <div class="item-body">
            <el-select
              v-model="kibouShokushuCd"
              filterable
              placeholder="選択してください"
              style="left: 0; max-width: 100%"
            >
              <el-option-group
                v-for="group in bizreachJobCategoryGroups"
                :key="group.jgCd"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-option-group>
            </el-select>
          </div>
        </div>
      </PersonalRequestEditDialog>

      <!-- AI自動入力カード -->
      <div v-if="showAiCard" style="margin-top: 16px">
        <div v-if="requestAiLoading" class="text-center" style="padding: 20px">
          <i class="el-icon-loading" style="font-size: 24px"></i>
          <p style="margin-top: 8px; color: #909399">
            AIが入力データを分析中...
          </p>
        </div>
        <div
          v-else-if="requestAiError"
          style="
            padding: 12px;
            background: #fef0f0;
            border-radius: 4px;
            margin-bottom: 12px;
          "
        >
          <p style="color: #f56c6c; margin: 0">{{ requestAiError }}</p>
        </div>
        <div v-else-if="requestAiGenerated">
          <div style="background: #f5f7fa; border-radius: 4px; padding: 12px">
            <div style="margin-bottom: 8px">
              <span style="color: #909399; font-size: 12px">役職・部署名:</span>
              <span>{{ yakushokuBusho || '(未設定)' }}</span>
            </div>
            <div style="margin-bottom: 8px">
              <span style="color: #909399; font-size: 12px">希望業種:</span>
              <span>{{ getIndustryName(kibouGyoushuCd) || '(未設定)' }}</span>
            </div>
            <div style="margin-bottom: 8px">
              <span style="color: #909399; font-size: 12px">希望職種:</span>
              <span>{{
                getJobCategoryName(kibouShokushuCd) || '(未設定)'
              }}</span>
            </div>
            <div style="text-align: right">
              <el-button
                size="small"
                type="danger"
                @click="requestEditDialogVisible = true"
                >編集</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue'
import PersonalRequestEditDialog from '@/components/format-edit/PersonalRequestEditDialog.vue'
import type { BasicData } from '@/utils/format-edit/basicData'

type SelectOption = {
  value: string
  label: string
}

type OptionGroup = {
  igCd?: string
  jgCd?: string
  label: string
  options?: SelectOption[]
}

const props = withDefaults(
  defineProps<{
    mode?: 'fields' | 'ai-card'
    formatData: Record<string, unknown>
    basicData: BasicData
    formatId: string
    industryData: OptionGroup[]
    jobTypeData: OptionGroup[]
    showAiCard?: boolean
    requestAiGenerated?: boolean
    requestAiLoading?: boolean
    requestAiError?: string
    bizreachIndustryGroups?: OptionGroup[]
    bizreachJobCategoryGroups?: OptionGroup[]
    getIndustryName?: (cd: unknown) => string
    getJobCategoryName?: (cd: unknown) => string
  }>(),
  {
    mode: 'fields',
    showAiCard: false,
    requestAiGenerated: false,
    requestAiLoading: false,
    requestAiError: '',
    bizreachIndustryGroups: () => [],
    bizreachJobCategoryGroups: () => [],
    getIndustryName: () => '',
    getJobCategoryName: () => ''
  }
)

const emit = defineEmits<{
  (e: 'update-basic-data', payload: Record<string, unknown>): void
  (e: 'update-format-data', payload: Record<string, unknown>): void
}>()

const requestEditDialogVisible = ref(false)

function emittedBasicField(key: keyof BasicData) {
  return computed({
    get: () => props.basicData[key],
    set: (value: unknown) => emit('update-basic-data', { [key]: value })
  })
}

function emittedFormatField(key: string) {
  return computed({
    get: () => props.formatData[key],
    set: (value: unknown) => emit('update-format-data', { [key]: value })
  })
}

const yakushokuBusho = emittedBasicField('yakushokuBusho')
const gyoushuCd = emittedBasicField('gyoushuCd')
const shokushuCd = emittedBasicField('shokushuCd')
const kibouGyoushuCd = emittedBasicField('kibouGyoushuCd')
const kibouShokushuCd = emittedBasicField('kibouShokushuCd')
const nowNensyu = emittedFormatField('nowNensyu')
const kibouNensyu = emittedFormatField('kibouNensyu')

function labelForCd(groups: OptionGroup[] | undefined, cd: unknown): string {
  if (!cd) return ''
  for (const group of groups || []) {
    for (const item of group.options || []) {
      if (item && item.value === cd) return item.label
    }
  }
  return ''
}

onMounted(() => {
  if (!('currentIndustrycategory' in props.formatData)) {
    emit('update-format-data', { currentIndustrycategory: '' })
  }
  if (!('currentJobcategory' in props.formatData)) {
    emit('update-format-data', { currentJobcategory: '' })
  }
})

watch(
  () => props.basicData.gyoushuCd,
  (newCd) => {
    emit('update-format-data', {
      currentIndustrycategory: labelForCd(props.industryData, newCd)
    })
  }
)
watch(
  () => props.basicData.shokushuCd,
  (newCd) => {
    emit('update-format-data', {
      currentJobcategory: labelForCd(props.jobTypeData, newCd)
    })
  }
)
</script>
